<ng-container *ngIf="transactionType === 1">
  <div class="transactions-card">
    <div class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Net Sales" | translate | async }}
              <div>
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.netSalesPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.netSalesPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.netSalesPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.netSalesPercentage)
                          ? summary.netSalesPercentage
                          : showPlusData(summary.netSalesPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.netSalesPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.netSalesPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.netSalesPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <ng-container *ngIf="summary.netSales === '-'">{{
                transactions.length > 0 ? summary.netSales : "0.00"
              }}</ng-container>
              <ng-container *ngIf="summary.netSales !== '-'">
                <!-- ${{ currency$ | number : "1.2-2" }} -->
                <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                  {{ currency$ }}
                </div>
                <div class="currency-price-details currency-all-details">
                  {{
                    transactions.length > 0
                      ? (summary.netSales | number : "1.2-2")
                      : "0.00"
                  }}
                </div>
              </ng-container>
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="summary.transactions != null" class="col-mb-4">
      <div class="mini-card">
        <div class="row g-0">
          <div class="col-12">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Total Transactions" | translate | async }}
              <div>
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.transactionsPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.transactionsPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.transactionsPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.transactionsPercentage)
                          ? summary.transactionsPercentage
                          : showPlusData(summary.transactionsPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.transactionsPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.transactionsPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.transactionsPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              {{
                summary.transactions > 0
                  ? (summary.transactions | number : "1.0-2")
                  : 0
              }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="summary.transactions == null" class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Orders" | translate | async }}
              <span class="f-10 text-nowrap sucess-badge end-0 ms-0">
                <img src="assets/images/up-arrow-green.svg" />
                +0.2%</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              {{ summary.orders ? summary.orders : 0 }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="summary.closedTransactions != null" class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Closed Transactions" | translate | async }}
              <div>
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.closedPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.closedPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.closedPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.closedPercentage)
                          ? summary.closedPercentage
                          : showPlusData(summary.closedPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.closedPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.closedPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.closedPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              {{
                transactions.length > 0
                  ? (summary.closedTransactions | number : "1.0-2")
                  : 0
              }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="summary.closedTransactions == null" class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Closed Orders" | translate | async }}
              <span class="f-10 text-nowrap sucess-badge end-0 ms-0">
                <img src="assets/images/up-arrow-green.svg" />
                +0.2%</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              {{ summary.closedOrders ? summary.closedOrders : 0 }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Discounts" | translate | async }}
              <div>
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.discountsPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.discountsPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.discountsPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.discountsPercentage)
                          ? summary.discountsPercentage
                          : showPlusData(summary.discountsPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.discountsPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.discountsPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.discountsPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <ng-container *ngIf="summary.discounts === '-'">{{
                transactions.length > 0 ? summary.discounts : "0.00"
              }}</ng-container>
              <ng-container *ngIf="summary.discounts !== '-'"
                >
                <!-- ${{ currency$ | number : "1.2-2" }} -->
                <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                  {{ currency$ }}
                </div>
                 <div class="currency-price-details currency-all-details">
                  {{
                    transactions.length > 0
                      ? (summary.discounts | number : "1.2-2")
                      : "0.00"
                  }}
                </div>
              </ng-container>
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ (taxAliasValue ? taxAliasValue : 'Taxes') | translate | async }}
              <div>
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.taxPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.taxPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.taxPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.taxPercentage)
                          ? summary.taxPercentage
                          : showPlusData(summary.taxPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.taxPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.taxPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.taxPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <ng-container *ngIf="summary.tax === '-'">{{
                transactions.length > 0 ? summary.tax : "0.00"
              }}</ng-container>
              <ng-container *ngIf="summary.tax !== '-'"
                >
                <!-- ${{ currency$ | number : "1.2-2" }} -->
                <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                  {{ currency$ }}
                </div>
              <div class="currency-price-details currency-all-details">
                {{
                  transactions.length > 0
                    ? (summary.tax | number : "1.2-2")
                    : "0.00"
                }}
               </div>
               </ng-container
              >
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Service Charge" | translate | async }}
              <div class="">
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.serviceChargesPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.serviceChargesPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.serviceChargesPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.serviceChargesPercentage)
                          ? summary.serviceChargesPercentage
                          : showPlusData(summary.serviceChargesPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.serviceChargesPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.serviceChargesPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.serviceChargesPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <!-- ${{ currency$ | number : "1.2-2" }} -->
              <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                {{ currency$ }}
              </div>
             <div class="currency-price-details currency-all-details">
              {{
                transactions.length > 0
                  ? (summary.serviceCharges | number : "1.2-2")
                  : "0.00"
              }}
             </div>
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Tips" | translate | async }}
              <div>
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.tipsPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.tipsPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.tipsPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.tipsPercentage)
                          ? summary.tipsPercentage
                          : showPlusData(summary.tipsPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.tipsPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.tipsPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.tipsPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <!-- ${{ currency$ | number : "1.2-2" }} -->
              <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                {{ currency$ }}
              </div>
                <div class="currency-price-details currency-all-details">
                  {{
                    transactions.length > 0
                      ? (summary.tips | number : "1.2-2")
                      : "0.00"
                  }}
                </div>
              </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Delivery Fees" | translate | async }}
              <div>
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.deliveryAmountPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.deliveryAmountPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.deliveryAmountPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.deliveryAmountPercentage)
                          ? summary.deliveryAmountPercentage
                          : showPlusData(summary.deliveryAmountPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.deliveryAmountPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.deliveryAmountPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.deliveryAmountPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <ng-container *ngIf="summary.tax === '-'"
                >{{ transactions.length > 0 ? summary.deliveryAmount : "0.00" }}
              </ng-container>
              <ng-container *ngIf="summary.tax !== '-'">
                <!-- ${{ currency$ | number : "1.2-2" }} -->
                <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                  {{ currency$ }}
                </div>
                  <div class="currency-price-details currency-all-details">{{
                    transactions.length > 0
                      ? (summary.deliveryAmount | number : "1.2-2")
                      : "0.00"
                  }}</div>
                </ng-container>
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="col-mb-2">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-12 text-start">
            <div class="f-12 fw-600 tran-card-details">
              {{ "Total Sales" | translate | async }}
              <div>
                <div class="text-end">
                  <div class="d-flex">
                    <span
                      *ngIf="summary.totalAmountPercentage != undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.totalAmountPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.totalAmountPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      {{
                        checkNegative(summary.totalAmountPercentage)
                          ? summary.totalAmountPercentage
                          : showPlusData(summary.totalAmountPercentage)
                      }}%</span
                    >
                    <span
                      *ngIf="summary.totalAmountPercentage == undefined"
                      class="f-12 me-2"
                      [ngClass]="
                        checkNegative(summary.totalAmountPercentage)
                          ? 'danger-badge'
                          : checkZeroInc(summary.totalAmountPercentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                    >
                      0.00 %</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <!-- ${{ currency$ | number : "1.2-2" }} -->
              <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                {{ currency$ }}
              </div>
              <div class="currency-price-details currency-all-details"> {{
                transactions.length > 0
                ? (summary.totalAmount | number : "1.2-2")
                : "0.00"
                }}</div>
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="transactionType === 2">
  <div class="transactions-card">
    <div *ngIf="summary.transactions == null" class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ "Orders" | translate | async }}
              <!-- <span class="f-10 d-block text-nowrap sucess-badge end-0 ms-0">
                <img src="assets/images/up-arrow-green.svg" />
                +0.2%</span
              > -->
              <span
                *ngIf="summary.orderPercentage != undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.orderPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.orderPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                {{
                  checkNegative(summary.orderPercentage)
                    ? summary.orderPercentage
                    : showPlusData(summary.orderPercentage)
                }}%</span
              >
              <span
                *ngIf="summary.orderPercentage == undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.orderPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.orderPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                0.00 %</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              {{ summary.orders ? summary.orders : 0 }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="summary.closedTransactions != null" class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ "Closed Transactions" | translate | async }}
              <span class="f-10 d-block text-nowrap sucess-badge end-0 ms-0">
                <img src="assets/images/up-arrow-green.svg" />
                +0.2%</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              {{ transactions.length > 0 ? summary.closedTransactions : 0 }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="summary.closedTransactions == null" class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ "Closed Orders" | translate | async }}
              <!-- <span class="f-10 d-block text-nowrap sucess-badge end-0 ms-0">
                <img src="assets/images/up-arrow-green.svg" />
                +0.2%</span
              > -->
              <!-- <span class="f-10 d-block text-nowrap sucess-badge end-0 ms-0">
                <img src="assets/images/up-arrow-green.svg" />
                +0.2%</span
              > -->
              <span
                *ngIf="summary.closedPercentage != undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.closedPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.closedPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                {{
                  checkNegative(summary.closedPercentage)
                    ? summary.closedPercentage
                    : showPlusData(summary.closedPercentage)
                }}%</span
              >
              <span
                *ngIf="summary.closedPercentage == undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.closedPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.closedPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                0.00 %</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              {{ summary.closedOrders ? summary.closedOrders : 0 }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ "Net Sales" | translate | async }}
              <span
                *ngIf="summary.netSalesPercentage != undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.netSalesPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.netSalesPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                {{
                  checkNegative(summary.netSalesPercentage)
                    ? summary.netSalesPercentage
                    : showPlusData(summary.netSalesPercentage)
                }}%</span
              >
              <span
                *ngIf="summary.netSalesPercentage == undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.netSalesPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.netSalesPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                0.00 %</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <ng-container *ngIf="summary.netSales === '-'">{{
                transactions.length > 0 ? summary.netSales : "0.00"
              }}</ng-container>
              <ng-container *ngIf="summary.netSales !== '-'">
                <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                  {{ currency$ }}
                </div>
                  <div class="currency-price-details currency-all-details"> <span>
                    {{
                      transactions.length > 0
                        ? (summary.netSales | number : "1.2-2")
                        : "0.00"
                    }}
                  </span></div>
              </ng-container>
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="summary.transactions != null" class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ "Total Transactions" | translate | async }}
              <span class="f-10 d-block text-nowrap sucess-badge end-0 ms-0">
                <img src="assets/images/up-arrow-green.svg" />
                +0.2%</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              {{ summary.transactions > 0 ? summary.transactions : 0 }}
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ "Discounts" | translate | async }}
              <span
                *ngIf="summary.discountPercentage != undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.discountPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.discountPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                {{
                  checkNegative(summary.discountPercentage)
                    ? summary.discountPercentage
                    : showPlusData(summary.discountPercentage)
                }}%</span
              >
              <span
                *ngIf="summary.discountPercentage == undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.discountPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.discountPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                0.00 %</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <ng-container *ngIf="summary.discounts === '-'">{{
                transactions.length > 0 ? summary.discounts : "0.00"
              }}</ng-container>
              <ng-container *ngIf="summary.discounts !== '-'">
                <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                  {{ currency$ }}
                </div>
                  <div class="currency-price-details currency-all-details">  <span>
                    {{
                      transactions.length > 0
                        ? (summary.discounts | number : "1.2-2")
                        : "0.00"
                    }}
                  </span></div>
                </ng-container>
            </h6>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ "Gross Sales" | translate | async }}
              <span
                *ngIf="summary.grossSalesPercentage != undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.grossSalesPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.grossSalesPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                {{
                  checkNegative(summary.grossSalesPercentage)
                    ? summary.grossSalesPercentage
                    : showPlusData(summary.grossSalesPercentage)
                }}%</span
              >
              <span
                *ngIf="summary.grossSalesPercentage == undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.grossSalesPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.grossSalesPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                0.00 %</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                {{ currency$ }}
              </div>
                <div class="currency-price-details currency-all-details"> <span> {{
                  transactions.length > 0
                    ? (summary.grossSales | number : "1.2-2")
                    : "0.00"
                }}</span> </div>
             </h6>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ (taxAliasValue ? taxAliasValue : 'Taxes') | translate | async }}
              <span
                *ngIf="summary.taxPercentage != undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.taxPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.taxPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                {{
                  checkNegative(summary.taxPercentage)
                    ? summary.taxPercentage
                    : showPlusData(summary.taxPercentage)
                }}%</span
              >
              <span
                *ngIf="summary.taxPercentage == undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.taxPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.taxPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                0.00 %</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <ng-container *ngIf="summary.tax === '-'">{{
                transactions.length > 0 ? summary.tax : "0.00"
              }}</ng-container>
              <ng-container *ngIf="summary.tax !== '-'">
                <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                  {{ currency$ }}
                </div>
                  <div class="currency-price-details currency-all-details"><span>
                    {{
                      transactions.length > 0
                        ? (summary.tax | number : "1.2-2")
                        : "0.00"
                    }}
                  </span> </div></ng-container
              >
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600 d-flex flex-column">
              {{ "Tips" | translate | async }}
              <span
                *ngIf="summary.tipsPercentage != undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.tipsPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.tipsPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                {{
                  checkNegative(summary.tipsPercentage)
                    ? summary.tipsPercentage
                    : showPlusData(summary.tipsPercentage)
                }}%</span
              >
              <span
                *ngIf="summary.tipsPercentage == undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.tipsPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.tipsPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                0.00 %</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                {{ currency$ }}
              </div>
                <div class="currency-price-details currency-all-details">
                  <span>
                    {{
                      transactions.length > 0
                        ? (summary.tips | number : "1.2-2")
                        : "0.00"
                    }}
                  </span></div>

            </h6>
          </div>
        </div>
      </div>
    </div>

    <div class="">
      <div class="mini-card h-100">
        <div class="row g-0">
          <div class="col-9 text-start">
            <div class="f-12 fw-600">
              {{ "Total Sales" | translate | async }}
              <!-- <span class="f-10 d-block text-nowrap sucess-badge end-0 ms-0">
                <img src="assets/images/up-arrow-green.svg" />
                +0.2%</span
              > -->
              <span
                *ngIf="summary.totalAmountPercentage != undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.totalAmountPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.totalAmountPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                {{
                  checkNegative(summary.totalAmountPercentage)
                    ? summary.totalAmountPercentage
                    : showPlusData(summary.totalAmountPercentage)
                }}%</span
              >
              <span
                *ngIf="summary.totalAmountPercentage == undefined"
                class="f-12 me-2"
                [ngClass]="
                  checkNegative(summary.totalAmountPercentage)
                    ? 'danger-badge'
                    : checkZeroInc(summary.totalAmountPercentage)
                    ? 'zero-badge'
                    : 'sucess-badge'
                "
              >
                0.00 %</span
              >
            </div>
            <h6 class="fw-500 f-17 position_bottom mt-1">
              <div class="currency-name-details currency-all-details" [style.width]="currencyWidth">
                {{ currency$ }}
              </div>
                <div class="currency-price-details currency-all-details">
                  <span>
                  {{
                    transactions.length > 0
                      ? (summary.totalAmount | number : "1.2-2")
                      : "0.00"
                  }}
                  </span>
                </div>
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
